import React, { useEffect } from 'react'
import { Route, withRouter } from 'react-router-dom'
import { Redirect, Switch } from 'react-router'
import { inject, observer } from 'mobx-react'
import strings from '../../lang/strings'
import Menu, { Extra } from '../../config/page_route.jsx'
import { setMetaTags } from '../metatags/metatags.js'

const Content = ({ history, rootStore }) => {
  const routes = [...Extra, ...Menu]

  const setGlobalTags = path => {
    if (path.includes('/bj/detail')) return;
    let pageTitle = strings.app_name
    const defaultDescription = strings.description
    const defaultImage = strings.ogImage
    const route = routes.find(it => it.path == path || it.children?.some(c => c.path == path))
    if (route) {
      if (route.path == path) {
        pageTitle = route.title
      } else {
        pageTitle = route.children?.find(it => it.path == path)?.title
      }
    }

    setMetaTags(pageTitle, defaultDescription, defaultImage )
  }

  const getRoute = (route, index) =>
    <Route
      key={index}
      path={route.path}
      exact={route.exact}
      component={
        !route.private || rootStore.isSignedIn ? route.component : () => <Redirect to='/login' />
      }
    />

  useEffect(() => {
    window.scrollTo(0,0)
    history.listen(() => {
      setGlobalTags(history.location.pathname)
    })
    setGlobalTags(history.location.pathname)
  })

  return (
    <div className={`content`}>
      <Switch>
        {routes.map((route, index) => {
          if (route.hasOwnProperty('children')) {
            return route.children.map((subRoute, subIndex) =>
              getRoute(subRoute, subIndex))
          } else {
            return getRoute(route, index)
          }
        })}
        <Route component={() => <Redirect to='/dashboard' />} />
      </Switch>
    </div>
  )
}

export default withRouter(inject('rootStore')(observer(Content)))
